
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as aboutBcrxsER0t1Meta } from "/var/www/pages/about.vue?macro=true";
import { default as add_45cardaxRWGP1OlbMeta } from "/var/www/pages/add-card.vue?macro=true";
import { default as indexQpk1DS6CIqMeta } from "/var/www/pages/appointments/index.vue?macro=true";
import { default as checkoutHSdaqX6veOMeta } from "/var/www/pages/checkout.vue?macro=true";
import { default as contactONBBCDEUx7Meta } from "/var/www/pages/contact.vue?macro=true";
import { default as cookie_45noticeblReLjQWx5Meta } from "/var/www/pages/cookie-notice.vue?macro=true";
import { default as cookie_45preferencesg7AnHrc1rXMeta } from "/var/www/pages/cookie-preferences.vue?macro=true";
import { default as date_45selector_45demoN5lfTqXryFMeta } from "/var/www/pages/date-selector-demo.vue?macro=true";
import { default as _91id_93tzsdYjTqG0Meta } from "/var/www/pages/doctor/[id].vue?macro=true";
import { default as faqsRpOPm5gBVxMeta } from "/var/www/pages/faqs.vue?macro=true";
import { default as forget_45passwordNUk3wdm6SiMeta } from "/var/www/pages/forget-password.vue?macro=true";
import { default as getting_45started47ZcIZXtCrMeta } from "/var/www/pages/getting-started.vue?macro=true";
import { default as helpiZTWajUt7xMeta } from "/var/www/pages/help.vue?macro=true";
import { default as indexTNebhwOASsMeta } from "/var/www/pages/index.vue?macro=true";
import { default as loginal8vo3imt1Meta } from "/var/www/pages/login.vue?macro=true";
import { default as medicine_45refillsXgClNX5xDSMeta } from "/var/www/pages/medicine-refills.vue?macro=true";
import { default as online_45consultations8fxc6O7akzMeta } from "/var/www/pages/online-consultations.vue?macro=true";
import { default as patient_45selectionT8asj1ZDvZMeta } from "/var/www/pages/patient-selection.vue?macro=true";
import { default as _91id_93Xd7zB5OuthMeta } from "/var/www/pages/patient/[id].vue?macro=true";
import { default as createyIMYpmci6BMeta } from "/var/www/pages/patient/create.vue?macro=true";
import { default as indexNOzgP2FqZ9Meta } from "/var/www/pages/patient/index.vue?macro=true";
import { default as prescriptionswOoUfmJ5qaMeta } from "/var/www/pages/prescriptions.vue?macro=true";
import { default as privacyQZo9zewEj2Meta } from "/var/www/pages/privacy.vue?macro=true";
import { default as editWTXc8S0ZJqMeta } from "/var/www/pages/profile/edit.vue?macro=true";
import { default as index6mvdsxEtRUMeta } from "/var/www/pages/profile/index.vue?macro=true";
import { default as report_45issueMs5NcW5yrwMeta } from "/var/www/pages/report-issue.vue?macro=true";
import { default as reset_45passwordGLyiKNoYoGMeta } from "/var/www/pages/reset-password.vue?macro=true";
import { default as _91specialty_93Kg9SgunZrhMeta } from "/var/www/pages/service/[type]/[specialty].vue?macro=true";
import { default as servicesDvunHrsqq2Meta } from "/var/www/pages/services.vue?macro=true";
import { default as signupOFOdEv1GJLMeta } from "/var/www/pages/signup.vue?macro=true";
import { default as termsS0lNqlMMeVMeta } from "/var/www/pages/terms.vue?macro=true";
import { default as trust_45center4Y7xFBX3twMeta } from "/var/www/pages/trust-center.vue?macro=true";
import { default as verifyCKvp1GdouaMeta } from "/var/www/pages/verify.vue?macro=true";
export default [
  {
    name: "about___en",
    path: "/en/about",
    component: () => import("/var/www/pages/about.vue")
  },
  {
    name: "about___ar",
    path: "/about",
    component: () => import("/var/www/pages/about.vue")
  },
  {
    name: "add-card___en",
    path: "/en/add-card",
    meta: add_45cardaxRWGP1OlbMeta || {},
    component: () => import("/var/www/pages/add-card.vue")
  },
  {
    name: "add-card___ar",
    path: "/add-card",
    meta: add_45cardaxRWGP1OlbMeta || {},
    component: () => import("/var/www/pages/add-card.vue")
  },
  {
    name: "appointments___en",
    path: "/en/appointments",
    meta: indexQpk1DS6CIqMeta || {},
    component: () => import("/var/www/pages/appointments/index.vue")
  },
  {
    name: "appointments___ar",
    path: "/appointments",
    meta: indexQpk1DS6CIqMeta || {},
    component: () => import("/var/www/pages/appointments/index.vue")
  },
  {
    name: "checkout___en",
    path: "/en/checkout",
    component: () => import("/var/www/pages/checkout.vue")
  },
  {
    name: "checkout___ar",
    path: "/checkout",
    component: () => import("/var/www/pages/checkout.vue")
  },
  {
    name: "contact___en",
    path: "/en/contact",
    component: () => import("/var/www/pages/contact.vue")
  },
  {
    name: "contact___ar",
    path: "/contact",
    component: () => import("/var/www/pages/contact.vue")
  },
  {
    name: "cookie-notice___en",
    path: "/en/cookie-notice",
    component: () => import("/var/www/pages/cookie-notice.vue")
  },
  {
    name: "cookie-notice___ar",
    path: "/cookie-notice",
    component: () => import("/var/www/pages/cookie-notice.vue")
  },
  {
    name: "cookie-preferences___en",
    path: "/en/cookie-preferences",
    component: () => import("/var/www/pages/cookie-preferences.vue")
  },
  {
    name: "cookie-preferences___ar",
    path: "/cookie-preferences",
    component: () => import("/var/www/pages/cookie-preferences.vue")
  },
  {
    name: "date-selector-demo___en",
    path: "/en/date-selector-demo",
    component: () => import("/var/www/pages/date-selector-demo.vue")
  },
  {
    name: "date-selector-demo___ar",
    path: "/date-selector-demo",
    component: () => import("/var/www/pages/date-selector-demo.vue")
  },
  {
    name: "doctor-id___en",
    path: "/en/doctor/:id()",
    meta: _91id_93tzsdYjTqG0Meta || {},
    component: () => import("/var/www/pages/doctor/[id].vue")
  },
  {
    name: "doctor-id___ar",
    path: "/doctor/:id()",
    meta: _91id_93tzsdYjTqG0Meta || {},
    component: () => import("/var/www/pages/doctor/[id].vue")
  },
  {
    name: "faqs___en",
    path: "/en/faqs",
    component: () => import("/var/www/pages/faqs.vue")
  },
  {
    name: "faqs___ar",
    path: "/faqs",
    component: () => import("/var/www/pages/faqs.vue")
  },
  {
    name: "forget-password___en",
    path: "/en/forget-password",
    meta: forget_45passwordNUk3wdm6SiMeta || {},
    component: () => import("/var/www/pages/forget-password.vue")
  },
  {
    name: "forget-password___ar",
    path: "/forget-password",
    meta: forget_45passwordNUk3wdm6SiMeta || {},
    component: () => import("/var/www/pages/forget-password.vue")
  },
  {
    name: "getting-started___en",
    path: "/en/getting-started",
    component: () => import("/var/www/pages/getting-started.vue")
  },
  {
    name: "getting-started___ar",
    path: "/getting-started",
    component: () => import("/var/www/pages/getting-started.vue")
  },
  {
    name: "help___en",
    path: "/en/help",
    component: () => import("/var/www/pages/help.vue")
  },
  {
    name: "help___ar",
    path: "/help",
    component: () => import("/var/www/pages/help.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/var/www/pages/index.vue")
  },
  {
    name: "index___ar",
    path: "/",
    component: () => import("/var/www/pages/index.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    meta: loginal8vo3imt1Meta || {},
    component: () => import("/var/www/pages/login.vue")
  },
  {
    name: "login___ar",
    path: "/login",
    meta: loginal8vo3imt1Meta || {},
    component: () => import("/var/www/pages/login.vue")
  },
  {
    name: "medicine-refills___en",
    path: "/en/medicine-refills",
    component: () => import("/var/www/pages/medicine-refills.vue")
  },
  {
    name: "medicine-refills___ar",
    path: "/medicine-refills",
    component: () => import("/var/www/pages/medicine-refills.vue")
  },
  {
    name: "online-consultations___en",
    path: "/en/online-consultations",
    component: () => import("/var/www/pages/online-consultations.vue")
  },
  {
    name: "online-consultations___ar",
    path: "/online-consultations",
    component: () => import("/var/www/pages/online-consultations.vue")
  },
  {
    name: "patient-selection___en",
    path: "/en/patient-selection",
    component: () => import("/var/www/pages/patient-selection.vue")
  },
  {
    name: "patient-selection___ar",
    path: "/patient-selection",
    component: () => import("/var/www/pages/patient-selection.vue")
  },
  {
    name: "patient-id___en",
    path: "/en/patient/:id()",
    meta: _91id_93Xd7zB5OuthMeta || {},
    component: () => import("/var/www/pages/patient/[id].vue")
  },
  {
    name: "patient-id___ar",
    path: "/patient/:id()",
    meta: _91id_93Xd7zB5OuthMeta || {},
    component: () => import("/var/www/pages/patient/[id].vue")
  },
  {
    name: "patient-create___en",
    path: "/en/patient/create",
    component: () => import("/var/www/pages/patient/create.vue")
  },
  {
    name: "patient-create___ar",
    path: "/patient/create",
    component: () => import("/var/www/pages/patient/create.vue")
  },
  {
    name: "patient___en",
    path: "/en/patient",
    meta: indexNOzgP2FqZ9Meta || {},
    component: () => import("/var/www/pages/patient/index.vue")
  },
  {
    name: "patient___ar",
    path: "/patient",
    meta: indexNOzgP2FqZ9Meta || {},
    component: () => import("/var/www/pages/patient/index.vue")
  },
  {
    name: "prescriptions___en",
    path: "/en/prescriptions",
    component: () => import("/var/www/pages/prescriptions.vue")
  },
  {
    name: "prescriptions___ar",
    path: "/prescriptions",
    component: () => import("/var/www/pages/prescriptions.vue")
  },
  {
    name: "privacy___en",
    path: "/en/privacy",
    component: () => import("/var/www/pages/privacy.vue")
  },
  {
    name: "privacy___ar",
    path: "/privacy",
    component: () => import("/var/www/pages/privacy.vue")
  },
  {
    name: "profile-edit___en",
    path: "/en/profile/edit",
    component: () => import("/var/www/pages/profile/edit.vue")
  },
  {
    name: "profile-edit___ar",
    path: "/profile/edit",
    component: () => import("/var/www/pages/profile/edit.vue")
  },
  {
    name: "profile___en",
    path: "/en/profile",
    component: () => import("/var/www/pages/profile/index.vue")
  },
  {
    name: "profile___ar",
    path: "/profile",
    component: () => import("/var/www/pages/profile/index.vue")
  },
  {
    name: "report-issue___en",
    path: "/en/report-issue",
    component: () => import("/var/www/pages/report-issue.vue")
  },
  {
    name: "report-issue___ar",
    path: "/report-issue",
    component: () => import("/var/www/pages/report-issue.vue")
  },
  {
    name: "reset-password___en",
    path: "/en/reset-password",
    meta: reset_45passwordGLyiKNoYoGMeta || {},
    component: () => import("/var/www/pages/reset-password.vue")
  },
  {
    name: "reset-password___ar",
    path: "/reset-password",
    meta: reset_45passwordGLyiKNoYoGMeta || {},
    component: () => import("/var/www/pages/reset-password.vue")
  },
  {
    name: "service-type-specialty___en",
    path: "/en/service/:type()/:specialty()",
    meta: _91specialty_93Kg9SgunZrhMeta || {},
    component: () => import("/var/www/pages/service/[type]/[specialty].vue")
  },
  {
    name: "service-type-specialty___ar",
    path: "/service/:type()/:specialty()",
    meta: _91specialty_93Kg9SgunZrhMeta || {},
    component: () => import("/var/www/pages/service/[type]/[specialty].vue")
  },
  {
    name: "services___en",
    path: "/en/services",
    component: () => import("/var/www/pages/services.vue")
  },
  {
    name: "services___ar",
    path: "/services",
    component: () => import("/var/www/pages/services.vue")
  },
  {
    name: "signup___en",
    path: "/en/signup",
    meta: signupOFOdEv1GJLMeta || {},
    component: () => import("/var/www/pages/signup.vue")
  },
  {
    name: "signup___ar",
    path: "/signup",
    meta: signupOFOdEv1GJLMeta || {},
    component: () => import("/var/www/pages/signup.vue")
  },
  {
    name: "terms___en",
    path: "/en/terms",
    component: () => import("/var/www/pages/terms.vue")
  },
  {
    name: "terms___ar",
    path: "/terms",
    component: () => import("/var/www/pages/terms.vue")
  },
  {
    name: "trust-center___en",
    path: "/en/trust-center",
    component: () => import("/var/www/pages/trust-center.vue")
  },
  {
    name: "trust-center___ar",
    path: "/trust-center",
    component: () => import("/var/www/pages/trust-center.vue")
  },
  {
    name: "verify___en",
    path: "/en/verify",
    meta: verifyCKvp1GdouaMeta || {},
    component: () => import("/var/www/pages/verify.vue")
  },
  {
    name: "verify___ar",
    path: "/verify",
    meta: verifyCKvp1GdouaMeta || {},
    component: () => import("/var/www/pages/verify.vue")
  }
]